{
  "name": "komoot-test",
  "version": "1.4.0",
  "private": true,
  "description": "komoot job application test",
  "license": "MIT",
  "repository": "pke/komoot-test",
  "homepage": "https://komoot.pke.fyi/",
  "scripts": {
    "postinstall": "cd ./docs && npm ci",
    "dev": "parcel ./src/index.html",
    "dev:docs": "cd docs && npm run dev",
    "build:docs": "cd docs && npm run build",
    "_prebuild": "npm run build:docs",
    "build": "parcel build ./src/index.html --dist-dir ./public",
    "test": "jest tests/*.test.js --coverage",
    "testw": "npm t -- --watch",
    "lint:js": "eslint ./src/**/*.js",
    "lint:css": "stylelint ./src/**/*.css"
  },
  "author": {
    "name": "Philipp Kursawe",
    "email": "phil.kursawe+komoot@gmail.com",
    "url": "https://pke.fyi/"
  },
  "dependencies": {
    "core-js": "3.50.0",
    "leaflet": "1.9.4",
    "prop-types": "15.8.1",
    "react": "18.3.1",
    "react-dom": "18.3.1"
  },
  "devDependencies": {
    "@parcel/transformer-image": "2.16.4",
    "assert": "2.1.0",
    "chai": "4.5.0",
    "eslint": "8.57.1",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jsdoc": "48.11.0",
    "eslint-plugin-mocha": "10.5.0",
    "eslint-plugin-react": "7.37.5",
    "eslint-plugin-react-hooks": "7.1.1",
    "jest": "30.4.2",
    "parcel": "2.16.4",
    "postcss": "8.5.26",
    "posthtml-expressions": "1.11.4",
    "process": "0.11.10",
    "stylelint": "16.26.1",
    "stylelint-config-standard": "39.0.1"
  }
}
